module.exports = __webpack_public_path__ + "static/img/Group 1345.e4a4206.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images_member/20240302/Group 1345.png
// module id = tKlu
// module chunks = 1